import { Navigate } from 'react-router-dom';
import { isSubMatRouteAllowed } from '../utils/subMatCompany';

/**
 * GCLIENT 부자재 프로필에 따라 서류·템플릿 라우트 접근 제한.
 */
const SubMatGClientRouteGuard = ({ sessionUser, path, children }) => {
  if (!isSubMatRouteAllowed(sessionUser, path)) {
    return <Navigate to="/glass/dashboard" replace />;
  }
  return children;
};

export default SubMatGClientRouteGuard;
